export default __webpack_public_path__ + "static/media/busim-plansh2.157231ec.svg";